import { Fragment } from 'react'
import { ChevronRight } from 'lucide-react'

export function TimelineMini({ steps }: { steps: string[] }) {
  return (
    <div className="flex flex-wrap items-center gap-1 text-[11px] text-muted-foreground">
      {steps.map((s, i) => (
        <Fragment key={s}>
          <span className="rounded-md bg-muted px-1.5 py-0.5">{s}</span>
          {i < steps.length - 1 ? <ChevronRight className="size-3" /> : null}
        </Fragment>
      ))}
    </div>
  )
}
